import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import {isTouchPrimaryDevice} from 'lib/deviceUtils';

// One gate for all three annotation surfaces, so the toggle cannot appear
// without the banner and the capture handler.
export function useIsAnnotationModeAvailable(): boolean {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled('student_annotations');

  return isFeatureEnabled && !isLoading && !isTouchPrimaryDevice();
}
